import { render, staticRenderFns } from "./AddInspectionRoute.vue?vue&type=template&id=47ce17a7"
import script from "./AddInspectionRoute.vue?vue&type=script&lang=js"
export * from "./AddInspectionRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports